<template>
    <div>
        <p class="label" v-if="!hideLabel">{{ label }}</p>
        <v-autocomplete
                v-model="pickedId"
                :items="items"
                item-value="id"
                item-text="companyName"
                outlined
                hide-no-data
                :loading="isLoading"
                @change="onChange"
                :error-messages="errorMessages"
                hide-details="auto"
                class="mb-4"
                v-bind="$attrs"
        ></v-autocomplete>
    </div>
</template>

<script>
  import IdentityService from '@/services/identity.service.js';

  export default {
    name: "IdentityPickerInput",
    props: {
      value: {},
      label: {type: String, default: 'Expéditeur'},
      placeholder: {type: String, default: 'Select...'},
      hideLabel: { type: Boolean, default: false},
      errorMessages: {}
    },
    data() {
      return {
        items: [],
        pickedId: null,
        isLoading: false
      }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      loadListItem() {
        if (this.isLoading) return;

        this.isLoading = true;

        const _this = this;

        IdentityService.getAll()
          .then(({data}) => {
            console.log(data);
              _this.items = data;
            })
          .finally(() => {
            _this.isLoading = false;
          })
      },
      onChange(value) {
        this.$emit('input', value);
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          this.pickedId = value;
        }
      }
    }
  }
</script>

<style scoped>

</style>
